import { useCurrentUserData } from '../../../../Auth';
import { CreditBalanceMenu } from './CreditBalanceMenu';
import { CreditOfferMenu } from './CreditOfferMenu';

export const CreditsBanner = () => {
  const { purchasedPackages, customerRole, hidePrices } = useCurrentUserData();

  if (hidePrices) {
    return null;
  }

  if (customerRole === 'manager') {
    return null;
  }

  if (customerRole === 'owner' && !purchasedPackages) {
    return <CreditOfferMenu />;
  }

  // Owners or admins shall be able to see credit balance
  return <CreditBalanceMenu />;
};
